/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { AccountEntity } from './account-entity';
import { ContactEntity } from './contact-entity';
export class ContactsAccountEntity extends Entity {
  account: AccountEntity | null = null;
  accountId: string | null = null;
  contact: ContactEntity | null = null;
  contactId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  updatedAt: string | null = null;
  static override key = 'ContactsAccount';
  static override get schema() {
    return {
      account: AccountEntity,
      contact: ContactEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'ContactsAccount' in input
    ) {
      const { ContactsAccount: wrapped, ...rest } = input as {
        ContactsAccount: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}